<template>
  <div id="hours-tracked">
    <Filters
      v-model="form"
      :date-type="getDateType"
      :multiple-user-select="true"
      :user-placeholder="$t('All users')"
      @timezone-changed="updateTimezone"
    >
      <template #disabledData>
        <div class="w-100 h-100 centralize pb-1">
          <h3 v-if="activeTab !== 2">
            {{ activeTab === 0 ? FORMAT_DATE(form.date, 'DD MMM, YYYY') : FORMAT_DATE_RANGE(form.start_date, form.end_date) }}
          </h3>
        </div>
      </template>
    </Filters>
    <b-tabs
      id="tour-hours-tracked"
      v-model="activeTab"
      class="position-relative"
      pills
    >
      <div
        v-if="IS_MOBILE() && activeTab !== 2"
        class="d-flex justify-content-end w-100 mb-1"
      >
        <filter-dropdown :include-filters="['tags', 'isOnline', 'activities']" />

        <sort-by-filter
          :options="['HOURS_TRACKED', 'IDLE_DURATION', 'NAME']"
          :initial-sort-options="sortOptions"
          @update:sort-options="sortOptions = $event"
        />
      </div>
      <active-filters />

      <b-tab
        id="TODAY"
        :title="$t('Day')"
        active
        lazy
      >
        <result
          :show-chart="false"
          :start-date="todayDate.start_date"
          :end-date="todayDate.end_date"
          :user-id="form.userId"
          :timezone="form.time_zone"
          :sort-options="sortOptions"
          @update:sort-options="sortOptions = $event"
        />
      </b-tab>

      <b-tab
        id="DATE_RANGE"
        :title="$t('Date Range')"
        lazy
        @click="activeTab = 1"
      >
        <result
          :start-date="rangeDate.start_date"
          :end-date="rangeDate.end_date"
          :user-id="form.userId"
          :timezone="form.time_zone"
          :sort-options="sortOptions"
          @update:sort-options="sortOptions = $event"
        />
      </b-tab>
      <b-tab
        id="SUMMARY"
        :title="$t('Summary')"
        lazy
      >
        <Summary
          :start-date="monthRangeDate.start_date"
          :end-date="monthRangeDate.end_date"
          :user-id="form.userId"
          :timezone="form.time_zone"
        />
      </b-tab>

      <template #tabs-end>
        <div
          v-if="!IS_MOBILE() && activeTab !== 2"
          class="centralize position-absolute right-0"
        >
          <filter-dropdown :include-filters="['tags', 'isOnline', 'activities']" />

          <sort-by-filter
            :options="['HOURS_TRACKED', 'IDLE_DURATION', 'NAME']"
            :initial-sort-options="sortOptions"
            @update:sort-options="sortOptions = $event"
          />
        </div>
      </template>
    </b-tabs>

    <!-- <date-range-picker
      trigger-target="DATE_RANGE___BV_tab_button__"
      :start-date="form.start_date"
      :end-date="form.end_date"
      @change="(({ startDate, endDate}) => {
        form.start_date = startDate
        form.end_date = endDate
      })"
    /> -->
  </div>
</template>
<script>

import { getUserData } from '@/auth/utils'
import Filters from '@/views/common/components/Filter.vue'
import {
  BTab, BTabs,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'
import SortByFilter from '@/views/common/components/SortByFilter.vue'
import FilterDropdown from '@/views/common/components/Filters/FilterDropdown.vue'
import ActiveFilters from '@/views/common/components/Filters/ActiveFilters.vue'
// import DateRangePicker from '@/views/common/components/DateRangePicker.vue'
import Summary from './Summary.vue'
import Result from './Result.vue'

const moment = require('moment')

export default {
  components: {
    BTab,
    BTabs,
    Result,
    Filters,
    Summary,
    SortByFilter,
    FilterDropdown,
    ActiveFilters,
    // DateRangePicker,
  },
  data() {
    return {
      defaultUser: getUserData().uuid,
      form: {
        date: this.TODAY({ localTime: false }),
        start_date: moment(this.TODAY({ localTime: false })).startOf('month').format('YYYY-MM-DD'),
        end_date: this.TODAY({ localTime: false }),
        month_start: moment().format('YYYY-MM'),
        month_end: moment().format('YYYY-MM'),
        userId: this.defaultUser,
        time_zone: localStorage.timezone ?? 'Asia/Kathmandu',
      },
      activeTab: 0,
      sortOptions: {
        sortBy: 'HOURS_TRACKED',
        sortDirection: 'DESC',
      },
    }
  },
  computed: {
    todayDate() {
      return {
        start_date: `${this.form.date} 00:00:00`,
        end_date: this.ADD_DAYS(this.form.date, 1, 'YYYY-MM-DD 00:00:00').start,
      }
    },
    rangeDate() {
      return {
        start_date: `${this.form.start_date} 00:00:00`,
        end_date: this.ADD_DAYS(this.form.end_date, 1, 'YYYY-MM-DD 00:00:00').start,
      }
    },
    monthRangeDate() {
      const monthStart = `${this.form.month_start}-01`
      const monthEnd = moment(`${this.form.month_end}-01`).endOf('month').format('YYYY-MM-DD')
      return {
        start_date: `${monthStart} 00:00:00`,
        end_date: this.ADD_DAYS(monthEnd, 1, 'YYYY-MM-DD 00:00:00').start,
      }
    },
    getDateType() {
      if (this.activeTab === 0) {
        return 'single'
      } if (this.activeTab === 2) {
        return 'month'
      }
      return 'range'
    },
  },
  watch: {
    'form.userId': {
      handler(val) {
        if (val && val.length) {
          this.setSelectedUser(val[0])
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions('project', ['setSelectedUser']),
    updateTimezone() {
      if (this.isAfterTODAY(this.form.date)) this.form.date = this.TODAY({ localTime: false })
      if (this.isAfterTODAY(this.form.start_date)) this.form.start_date = this.TODAY({ localTime: false })
      if (this.isAfterTODAY(this.form.end_date)) this.form.end_date = this.TODAY({ localTime: false })
    },
  },
}
</script>
